import { render, staticRenderFns } from "./MobileNavPrimaryItem.vue?vue&type=template&id=546057a6&"
import script from "./MobileNavPrimaryItem.vue?vue&type=script&lang=js&"
export * from "./MobileNavPrimaryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports